import FormLabel from '../FormLabel/FormLabel';
import Input, { InputProps } from '../Input/Input';
import { styles } from './FormInput.styles';

interface FormInputProps {
  errorMessage?: string;
  hint?: string;
  inputName?: string;
  labelText?: string;
  value?: string;
  labelIsAlignedLeft?: boolean;
  pattern?: RegExp;
  onChange: (value: string) => void;
  errorWithoutMessage?: boolean;
  inputProps?: Omit<InputProps, 'onChange' | 'value' | 'name'>;
}

const FormInput = (props: FormInputProps) => {
  const {
    inputName,
    errorMessage,
    errorWithoutMessage,
    hint,
    labelText,
    onChange,
    value,
    labelIsAlignedLeft,
    pattern,
    inputProps = {},
  } = props;

  const { required, type, ...restInputProps } = inputProps;

  return (
    <div className='FormInput'>
      {labelText && (
        <FormLabel
          htmlFor={inputName}
          labelText={labelText}
          isAlignedLeft={labelIsAlignedLeft}
          withRequiredMark={required}
        />
      )}

      <div className='FormInput__Input'>
        <Input
          hasError={!!errorMessage || errorWithoutMessage}
          onChange={onChange}
          value={value}
          pattern={pattern}
          required={required}
          name={inputName}
          type={type}
          {...restInputProps}
        />
      </div>

      {hint && (
        <div className='FormInput__hint' data-testid='formInputHint'>
          {hint}
        </div>
      )}

      {errorMessage && (
        <div className='FormInput__errorMessage' data-testid='formInputErrorMessage' role='alert'>
          {errorMessage}
        </div>
      )}

      <style jsx>{styles}</style>
    </div>
  );
};

export default FormInput;
